import React, { Component } from 'react';
import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export function FloatingWhatsApp() {
  const href = 'https://wa.link/lvbw8v';
  return <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-2" data-id="element-80">
      <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 2,
      duration: 0.5
    }} className="bg-mystic-white text-mystic-black px-3 py-1.5 rounded-lg text-sm font-medium shadow-lg relative mr-2" data-id="element-81">
        Habla conmigo
        <div className="absolute -bottom-1.5 right-4 w-3 h-3 bg-mystic-white transform rotate-45" data-id="element-82"></div>
      </motion.div>

      <a href={href} target="_blank" rel="noopener noreferrer" className="relative group" aria-label="Contactar por WhatsApp" data-id="element-83">
        <div className="absolute inset-0 bg-whatsapp rounded-full animate-ping opacity-40 group-hover:opacity-60 transition-opacity" data-id="element-84"></div>
        <div className="relative bg-whatsapp text-white p-4 rounded-full shadow-[0_4px_20px_rgba(37,211,102,0.5)] transform transition-transform group-hover:scale-110" data-id="element-85">
          <MessageCircle className="w-8 h-8" data-id="element-86" />
        </div>
      </a>
    </div>;
}